module.exports = __webpack_public_path__ + "static/media/add.fca4173c.svg";